@import "../../variables.scss";

.documentation {
  display: flex;
  flex-direction: column;
  margin: 0;

  @media (max-width: $size-lg) {
    min-height: 60vh;
    margin: 0 2rem;
    padding: 0 0 6rem;
    align-items: center;
  }

  @media (max-width: $size-md) {
    padding: 0 1rem 2rem;
    margin: 0;
  }

  &__header {
    padding: 2rem 1rem 0;
    @media (max-width: $size-lg) {
      width: 605px;
      padding: 3rem 0 0;
    }
    @media (max-width: $size-md) {
      width: 100%;
      padding: 2rem 0 0;
    }
  }
  &__title {
    font-size: 1.25rem;
    text-align: center;
    @media (max-width: $size-lg) {
      text-align: left;
    }
  }
  &__card {
    @media (max-width: $size-lg) {
      background-color: white;
      box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.25);
      border-radius: 4px;
      width: 605px;
    }

    @media (max-width: $size-md) {
      margin: 0 1rem 1rem;
      width: 100%;
    }
  }
}
